import React from 'react';
import styles from './setting-seperator.module.scss';
export const SettingSeperator = () => (React.createElement("div", { className: styles.settingSeperator }));
//# sourceMappingURL=setting-seperator.js.map